

import React from "react";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import { Table, Icon } from 'semantic-ui-react'

const EmployeeRecordValue = ({ rows }) => {
    const navigate = useNavigate()
    return (

        <>
            <Table>
                <Table.Header>
                <Table.Row>
                    <Table.HeaderCell width={1}>Org</Table.HeaderCell>
                    <Table.HeaderCell width={1}>Cred</Table.HeaderCell>
                    <Table.HeaderCell width={2}>Name</Table.HeaderCell>
                    <Table.HeaderCell width={2}>Status</Table.HeaderCell>
                    <Table.HeaderCell width={2}>Param</Table.HeaderCell>
                    <Table.HeaderCell width={2}>Status</Table.HeaderCell>
                    <Table.HeaderCell width={1}></Table.HeaderCell>
                    </Table.Row>
                </Table.Header>
                <Table.Body>
                    {rows && rows.map((row, i) => {
                        return (<Table.Row key={i}>
                            <Table.Cell>{row?.organization_id}</Table.Cell>
                            <Table.Cell>{row?.web_api_credential}</Table.Cell>
                            <Table.Cell>{row?.web_api_credential_name}</Table.Cell>
                            
                            <Table.Cell>{row?.status_text}</Table.Cell>
                            <Table.Cell>{row?.param}</Table.Cell>
                            <Table.Cell>{row?.status_text}</Table.Cell>
                            <Table.Cell>
                            {row?.id}
                            <Icon style={{cursor: "pointer"}} 
                            onClick={() => navigate(`/app/web-api-log/details/${row?.id}`)}
                            name='angle double right' />

                            </Table.Cell>
                        </Table.Row>
                        );
                    })}
                </Table.Body>
            </Table>
        </>
    )
};

EmployeeRecordValue.propTypes = {
    rows: PropTypes.array.isRequired,
};

export default EmployeeRecordValue;

